import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CirrusDividerComponent } from './cirrus-divider.component';

@NgModule({
  imports: [CommonModule],
  declarations: [CirrusDividerComponent],
  exports: [CirrusDividerComponent]
})
export class CirrusDividerModule {}
